export const config = {
  intro: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#ffd500',
      '#ffc800',
      '#ffa200',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  mult_land: {
    dropShadow: false,
    fill: '#ffffff',
    fontFamily: 'Druk Text Cy',
    fontSize: 45,
    fontWeight: 500,
    strokeThickness: 3,
  },
  mult_port: {
    dropShadow: false,
    fill: '#dbcb14',
    fontFamily: 'Druk Text Cy',
    fontSize: 45,
    fontWeight: 500,
    strokeThickness: 3,
  },
  total_win: {
    dropShadowAlpha: 0.6,
    dropShadowAngle: 0.7,
    dropShadowBlur: 2,
    fontSize: 60,
    dropShadowColor: '#5a1c00',
    dropShadowDistance: 0,
    fill: [
      '#f5dfb9',
      '#fff7d0',
    ],
    fontFamily: 'Druk Text Cy',
    letterSpacing: 2,
    lineJoin: 'bevel',
    stroke: '#5a1c00',
    strokeThickness: 3,
  },
}
